import { useEffect, useState } from 'react';

import RadioItem from '../radio-item/radio-item';
import styles from './index.module.scss';


interface radioItem {
  id: string;
  isChecked: boolean;
  title: string;
  desc: string;
  disabled: boolean;
  isSupport: boolean;
}

interface radioItemGroupProps {
  data: radioItem[];
  groupName: string;
  onChange: (value: string) => {};
  currentContent: any;
}

const RadioItemGroup = ({
  data,
  groupName,
  onChange,
  currentContent,
}: radioItemGroupProps) => {
  const [radioData, setRadioData] = useState(data);
  const [contentData, setContentData] = useState(currentContent);

  useEffect(() => {
    setRadioData(() => data);
  }, [data]);

  useEffect(() => {
    setContentData(currentContent);
  }, [currentContent]);

  return (
    <div className={styles['radio-item-group']}>
      {radioData.map((d) => {
        return (
          <RadioItem
            key={d.id}
            isChecked={d.isChecked}
            id={d.id}
            title={d.title}
            desc={d.desc}
            content={contentData}
            groupName={groupName}
            onClick={(id) => onChange(id)}
            disabled={d.disabled}
            isSupport={d.isSupport}
          />
        );
      })}
    </div>
  );
};

export default RadioItemGroup;
